export const settings = {
    "title": "Boulder 51",
    "description": "Boulder 51",
    "apiUrl": "https://localhost/api",
    "ckdPath": "https://localhost/"
}